module.exports = __webpack_public_path__ + "images/gradients/gradient-crystal.ed976169c339eeaef320.svg";